/**
 * Styled Components - Created by Alfredo on 02/05/25.
 */
import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 36px;
  width: 100%;
  margin-top: -16px;
  font-family: Avenir;
`

export const SizeRecDetailsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 17px;
  color: #302628;
  margin-inline: -8px;
  span {
    font-weight: 400;
  }
  span.name {
    font-weight: 600;
  }
  #info-section {
    background: #F7F7F7;
    border-radius: 6px;
    padding-block: 16px;
    padding-inline: 12px;
    max-width: 480px;
    width: 100%;
  }
  #profileSection {
    max-width: 400px;
    border-radius: 6px;
    margin-left: 28px;
    background: #F7F7F7;
    @media (max-width: 698px) {
      margin-inline: -8px;
    }
  }
  #quickIcon {
    max-width: 16px;
    border-radius: 25px;
    filter: invert(1) brightness(2);
    background: white;
    margin-left: 8px;
    cursor: pointer;
  }
  #profile {
    background: #00C7BE;
    color: white;
    border-radius: 25px;
    padding: 4px;
    margin-right: 4px;
    margin-bottom: 8px;
    font-size: 12px;
  }
`

export const FlexDiv = styled.div`
  display: flex;
  margin-bottom: 6px;
  .left {
    text-align: right;
    min-width: 50%;
    margin-right: 10px;
  }
`

export const StatusBadge = styled.div`
  margin-top: 22px !important;
  padding-bottom: 22px;
  border-radius: 6px;
  border: 1px solid #B3B3B3;
  background: #FFF;
  #header {
    margin-top: 0px !important; 
    overflow: hidden;
    padding-block 6px;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    color: #302628;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
  }
  #header.Processing {
    background: #FF9500;
  }
  #header.Pending {
    background: #FF3B30;
  }
  #header.Completed {
    background: #34C759;
  }
  #body {
    margin-top: 28px !important;
    display: flex;
    flex-flow: column;
  }
  #measurementDiv {
    max-width: 248px;
    text-align: center;
    margin: 22px auto;
  }
  #measurementBtn {
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 25px;
    margin-top: 30px;
    background: #302628;
    color: white;
    padding: 11px;
    width: 248px;
    height: 40px;
    font-weight: 500;
    font-family: Avenir;
    transition: color .25s, background .25s;
    &:hover {
      cursor: pointer;
      color: #302628;
      background: white;
    }
  }
`

export const FitContainer = styled.div`
  margin-top: 22px !important;
  padding-block: 12px 0;
  margin-inline: -6px;
  color: #302628;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  #caption {
    margin-inline: 26px;
    font-style: italic;
  }
  #container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 12px 26px;    
    padding-inline: 6px;
    border-radius: 6px;
    background: #E2E1E1;
    .name {
      padding: 4px 60px;
      border-radius: 4px;
      background: #F7F7F7;
      text-align: center;
      font-weight: 600;
    }
    p {
      margin-top: 12px
      text-align: center;
      line-height: 17px;
    }
    #zoom {
      position: absolute;
      right: 0px;
      top: 0px;
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  #fitPreferenceImg {
    margin-top: 12px;
    max-width: 224px;
    height: 226px;
    object-fit: cover;
  }
`

export const FitPreferenceNotes = styled.div`
  display: flex;
  padding: 16px;
  margin-inline: 20px;
  margin-top: 16px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 6px;
  background: #FFF;
  color: #989091;
  font-size: 14px;
  font-style: italic;
  line-height: normal;
  &>h6 {
    font-size: 14px;
    font-weight: 500;
    color: #302628;
  }
  &>p {
    font-weight: 400;
  }
  &#recommender-notes {
    margin-top: 20px;
    margin-inline: 2px;
    background: #d8f7e0;
    font-style: normal;
    color: #302628;
  }
`

export const MeasurementContainer = styled.div`
  margin-block: 22px !important;
  margin-inline: 16px;
  h6 {
    color: #302628;
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.042px;
  }
`

export const BackTo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px !important;
  span {
    margin-left: 4px;
    text-transform: capitalize;
    font-weight: normal;
    color: rgb(48, 38, 40);
    font-size: 14px;
  }
  &:hover {
    cursor: pointer;
    color: cornflowerblue;
  }
`

export const MeasureActionContainer = styled.div`
  margin-bottom: 16px;
  &>h6 {
    margin: 0px 20px 8px;
    font-size: 14px;
    font-family: "Avenir Next";
    font-weight: normal;
    font-style: italic;
  }
  #getMeasureActionContainer {
    border: 1px dashed #D7D1D2;
    margin-inline: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 240px;
    border-radius: 8px;
  }
  #getMeasureActionContainer #measurementBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 25px;
    margin-top: 30px;
    background: #302628;
    color: white;
    padding: 11px;
    width: 248px;
    height: 40px;
    font-weight: 500;
    font-family: Avenir;
    transition: color .25s, background .25s;
    &:hover {
      cursor: pointer;
      color: #302628;
      background: white;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SizeRecDetails/styledComponents.tsx